/* eslint-env browser */
import React, { useEffect, useRef, useState } from 'react'
import { Box, Grid, Typography } from '@material-ui/core'
import { useStyles } from './MemberDetails.style'
import Image from '../Image'
import LinkWithIcon from '../LinkWithIcon'

const PLACEHOLDER_IMAGE = '/assets/desktop/About/02-2%20Board.jpg'

const MemberDetails = (props) => {
  const { t, heading, description, personCard: members = [], link } = props
  const [expandedIndex, setExpandedIndex] = useState(null)
  const styles = useStyles()
  const containerRef = useRef(null)

  const handleToggle = (e, index) => {
    e.preventDefault()
    e.stopPropagation()
    setExpandedIndex(expandedIndex === index ? null : index)
  }

  useEffect(() => {
    if (expandedIndex === null) return undefined

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setExpandedIndex(null)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [expandedIndex])

  const hasDetails = (member) =>
    member.currentPositions?.length > 0 ||
    member.academicQualifications?.length > 0 ||
    member.previousExperience?.length > 0

  return (
    <>
      <Typography variant="h3" className={styles.teamTitle}>
        {heading}
      </Typography>
      <Typography variant="body1" className={styles.teamParagraph}>
        {description.description}
      </Typography>
      {members && (
        <Grid className={styles.teamMemberContainer} ref={containerRef}>
          {members.map((member, index) => {
            const imageUrl = member.imageUrl || PLACEHOLDER_IMAGE
            const isExpanded = expandedIndex === index
            const showKnowMore = hasDetails(member)

            return (
              <div
                className={`${styles.teamMemberCardLink} ${
                  isExpanded ? styles.cardWrapperExpanded : ''
                }`}
                key={index}
              >
                <Box className={styles.teamMemberCard}>
                  <Image
                    file={{ url: imageUrl }}
                    className={styles.memberImage}
                    title={member.personName}
                  />
                  <Box className={styles.teamMemberInfo}>
                    <Typography className={styles.teamMemberName}>
                      {member.personName}
                    </Typography>
                    <Typography variant="body2">
                      {member.designation}
                    </Typography>
                    {showKnowMore && (
                      <button
                        type="button"
                        className={styles.knowMoreButton}
                        onClick={(e) => handleToggle(e, index)}
                        aria-expanded={isExpanded}
                      >
                        {t('memberDetails.knowMore')} {isExpanded ? '↑' : '↓'}
                      </button>
                    )}
                  </Box>
                </Box>

                {isExpanded && showKnowMore && (
                  <Box className={styles.memberExpandedInfo}>
                    {member.currentPositions?.length > 0 && (
                      <>
                        <Typography className={styles.sectionHeading}>
                          {t('memberDetails.currentPositions')}
                        </Typography>
                        <ul className={styles.detailsList}>
                          {member.currentPositions.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </>
                    )}
                    {member.academicQualifications?.length > 0 && (
                      <>
                        <Typography className={styles.sectionHeading}>
                          {t('memberDetails.academicQualifications')}
                        </Typography>
                        <ul className={styles.detailsList}>
                          {member.academicQualifications.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </>
                    )}
                    {member.previousExperience?.length > 0 && (
                      <>
                        <Typography className={styles.sectionHeading}>
                          {t('memberDetails.previousExperience')}
                        </Typography>
                        <ul className={styles.detailsList}>
                          {member.previousExperience.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </Box>
                )}
              </div>
            )
          })}
        </Grid>
      )}
      {link && (
        <LinkWithIcon
          text={link.title}
          to={link.link}
          isExternal={link.isExternal}
        />
      )}
    </>
  )
}

export default MemberDetails
